
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/subject/[contentId]",
      function () {
        return require("private-next-pages/content/subject/[contentId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/subject/[contentId]"])
      });
    }
  